import React from 'react';
import {Box, Modal} from '@mui/material';
import ContestPreviewHeader from "./ContestPreviewHeader";
import MLBGamesStats from "../../../components/PlayerGamesStats/MLBStats/MLBGamesStats";
import NFLGamesStats from "../../../components/PlayerGamesStats/NFLStats/NFLGamesStats";
import SOCCERGamesStats from "../../../components/PlayerGamesStats/SOCCERStats/SOCCERGamesStats";
import NHLGamesStats from "../../../components/PlayerGamesStats/NHLStats/NHLGamesStats";
import NBAGamesStats from "../../../components/PlayerGamesStats/NBAStats/NBAGamesStats";

import './ContestPreviewPopUp.style.scss';
const ContestPreviewPopUp = ({id, title, subTitle, open, onClose, onCancel, onOk, options, data}) => {
    const contest = data;
    let gameStatsContent = null;

    switch (contest.player.League) {
        case 'MLB':
            gameStatsContent = <MLBGamesStats contest={contest}/>;
            break;
        case 'NFL':
            gameStatsContent = <NFLGamesStats contest={contest}/>;
            break;
        case 'SOCCER':
            gameStatsContent = <SOCCERGamesStats contest={contest}/>;
            break;
        case 'NHL':
            gameStatsContent = <NHLGamesStats contest={contest}/>;
            break;
        case 'NBA':
            gameStatsContent = <NBAGamesStats contest={contest}/>;
            break;
        default:
            break;
    }

    return (
        <Modal className={"ContestPreviewPopUp"} open={open} onClose={onClose}>
            <Box className="modalContainer">
                <button
                   className={"closeButton"}
                   onClick={onClose}>X</button>
                <ContestPreviewHeader contest={contest}/>
                {gameStatsContent}
            </Box>
        </Modal>
    );
};

export default ContestPreviewPopUp;
